;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import '../global.css'

import { CanaryClient } from '@qogita/deprecated-canary-client'
import { CanaryClientProvider } from '@qogita/deprecated-canary-client/provider'
import { TooltipProvider } from '@qogita/ui/providers/tooltip-provider'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { AppProps as NextAppProps } from 'next/app'
import { Figtree, Outfit } from 'next/font/google'
import Head from 'next/head'
import Script from 'next/script'
import { NuqsAdapter } from 'nuqs/adapters/next/pages'
import { useState } from 'react'
import { SELLERS_CANARY_APPLICATION } from 'src/core/canary-application'
import { BrowserObservabilityPagesRouter } from 'src/core/observability/browser-observability-pages-router'
import { IdentifyPosthogUserPagesRouter } from 'src/core/posthog/identify-posthog-user-pages-router'
import { RumProvider } from 'src/core/tracking/rum-provider'
import { AppAuthChecker } from 'src/deprecated/components/shared/AppAuthChecker'
import { ErrorBoundary } from 'src/deprecated/components/shared/ErrorBoundary'
import { DefaultErrorBoundaryFallback } from 'src/deprecated/components/shared/ErrorBoundary/ErrorBoundary'
import { AuthenticationProvider } from 'src/deprecated/contexts/Authentication'
import { LaunchDarklyProvider } from 'src/deprecated/contexts/LaunchDarkly'
import { queryClient } from 'src/deprecated/contexts/QueryClient'
import { UserProvider } from 'src/deprecated/contexts/User'
import { useAppAnalytics } from 'src/deprecated/hooks/utils/useAppAnalytics'
import { Page } from 'src/deprecated/types/next'
import { getAccessToken } from 'src/deprecated/utils/authentication'
import { env } from 'src/env.mjs'

const figtree = Figtree({
  subsets: ['latin'],
  style: 'normal',
  variable: '--font-figtree',
  display: 'swap',
})

const outfit = Outfit({
  subsets: ['latin'],
  style: 'normal',
  variable: '--font-outfit',
  display: 'swap',
})

type AppProps = NextAppProps & {
  Component: Page
}

function TrustpilotScript() {
  return (
    <Script
      id="trustpilot-script-loader"
      src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      strategy="lazyOnload"
    />
  )
}

/**
 * @description Sets up providers and analytics and basic meta tags
 */
function App({ Component, pageProps }: AppProps) {
  useAppAnalytics()

  const [canaryClient] = useState(
    () =>
      new CanaryClient({
        prefixUrl: env.NEXT_PUBLIC_API_BASE_URL,
        xQogitaApplication: SELLERS_CANARY_APPLICATION,
        beforeRequest: [
          async (request) => {
            const token = await getAccessToken()
            if (token) {
              request.headers.set('Authorization', `Bearer ${token}`)
            }
          },
        ],
      }),
  )

  return (
    <NuqsAdapter
      defaultOptions={{
        shallow: false,
      }}
    >
      <Head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Qogita</title>
      </Head>

      <CanaryClientProvider client={canaryClient}>
        <QueryClientProvider client={queryClient}>
          <AuthenticationProvider>
            <UserProvider>
              <ErrorBoundary fallback={<DefaultErrorBoundaryFallback />}>
                <LaunchDarklyProvider>
                  <AppAuthChecker options={Component.options}>
                    <main className={`${outfit.variable} ${figtree.variable}`}>
                      <TooltipProvider>
                        <RumProvider>
                          <Component {...pageProps} />
                        </RumProvider>
                      </TooltipProvider>
                    </main>
                  </AppAuthChecker>
                </LaunchDarklyProvider>
              </ErrorBoundary>
              <ErrorBoundary fallback={null}>
                <BrowserObservabilityPagesRouter />
              </ErrorBoundary>
              <ErrorBoundary fallback={null}>
                <IdentifyPosthogUserPagesRouter />
              </ErrorBoundary>
              <TrustpilotScript />
            </UserProvider>
          </AuthenticationProvider>

          <ReactQueryDevtools />
        </QueryClientProvider>
      </CanaryClientProvider>
    </NuqsAdapter>
  )
}

export default App
